module.exports = __webpack_public_path__ + "ru.svg?ca0208a9feee19f3e9a8789d9ac2dec7";